<div class="container">
  <div class="container-content ui-page-shell-modern">
    <app-listagem-lotes-repasse
      [headerItems]="headerItems"
    ></app-listagem-lotes-repasse>
  </div>
</div>
